import styled from '@emotion/styled';

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: ${({ theme }) => theme.spacing.sm};
`;
